import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import $ from 'jquery';
import Scanner from './_Scanner';

window.jQuery = $;
window.$ = $;

class Autocomplete extends Component {
  static propTypes = {
    suggestions: PropTypes.array
  };

  constructor(props) {
    super(props);

    this.state = {
      // The active selection's index
      activeSuggestion: -1,
      // The suggestions that match the user's input
      filteredSuggestions: [],
      // Whether or not the suggestion list is shown
      showSuggestions: false,
      // What the user has entered
      userInput: "",
      // value of item
      userValue: "",

      typing: false,
      typingTimeout: 0,
      isCloseSuggessDelegate: false,
      scanning: false,
    };

    this.onChange = this.onChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.showALl = this.showALl.bind(this);
    this.handleInputClick = this.handleInputClick.bind(this);
    this.scan = this.scan.bind(this);
    this.onDetected = this.onDetected.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  scan = () => {
    this.setState({ scanning: !this.state.scanning });
  }

  onDetected = (result) => {
    this.setValueBox(result.codeResult.code);
    this.scan();
  }

  onChange = (e) => {
    let { userInput } = this.state;
    userInput = userInput || "";
    let currentInput = $(e.currentTarget).val() || "";
    if (currentInput == "") {
      this.setState({
        activeSuggestion: -1,
        filteredSuggestions: [],
        showSuggestions: false,
        isCloseSuggessDelegate: false,
        userInput: currentInput
      });
    }
    else {
      const self = this;
      if (self.state.typingTimeout) {
        clearTimeout(self.state.typingTimeout);
      }
  
      self.setState({
        typing: false,
        typingTimeout: setTimeout(function () {
          self.setState({
            isCloseSuggessDelegate: false,
          });
          self.fetchData(currentInput);
          }, 400)
      });
    }
  };

  fetchData = (currentInput) =>  {
    if (this.props.handleChange && typeof this.props.handleChange == 'function') {
      this.props.handleChange(currentInput, () => {
        const { suggestions } = this.props;
        this.setState({
          activeSuggestion: -1,
          filteredSuggestions: suggestions,
          showSuggestions: true,
          userInput: currentInput
        });
      });
    }
    else {
      const { suggestions } = this.props;
      // Filter our suggestions that don't contain the user's input
      const filteredSuggestions = suggestions.filter(
        suggestion =>
          suggestion.label.toLowerCase().indexOf(currentInput.toLowerCase()) > -1
      );

      this.setState({
        activeSuggestion: -1,
        filteredSuggestions,
        showSuggestions: true,
        userInput: currentInput
      });
    }
  }
  
  onClick = (item) => {
    const { suggestions } = this.props;
    const activeSuggestion = suggestions.findIndex(x => x.value == item.value) || 0;
    
    this.setState({
      activeSuggestion: activeSuggestion,
      filteredSuggestions: [],
      showSuggestions: false,
      userInput: item.label || "",
      userValue: item.value || "",
    }, () => {
      if (item.value && item.value != "") {
        if (this.props.onSelection) {
          this.props.onSelection(item);
        }  
      }

      if (this.props.clearOnSelection) {
        this.handleClearClick();
      }
      else {
        this.setValueBox(item.label);
      }
    });
  };

  handleClearClick = e => {
    this.setState({
      activeSuggestion: -1,
      filteredSuggestions: [],
      showSuggestions: false,
      userInput: "",
      userValue: "",
    }, () => {
      this.setValueBox("");
      this.keywordInput.focus();
      if (this.props.handleClearClick && typeof this.props.handleClearClick === 'function') {
        this.props.handleClearClick()
      }
    });
  }

  setValueBox = (value) => {
    $(this.keywordInput).val(value || "");
  }

  getValueBox = () => {
    return $(this.keywordInput).val();
  }

  handleInputClick = e => {
    e.target.select();
  }
  handleOnKeyPress = (activeSuggestion, filteredSuggestions) => {
    const item = filteredSuggestions[activeSuggestion] || {}
    this.setState({
      showSuggestions: false,
      userInput: item.label || "",
      userValue: item.value || "",
    }, () => {
      if (item.value && item.value != "") {
        if (this.props.onSelection) {
          this.props.onSelection(item);
        }  
      }

      if (this.props.clearOnSelection) {
        this.handleClearClick();
      }
      else {
        this.setValueBox(item.label);
      }
    })
  }
  onKeyDown = e => {
    const { activeSuggestion, filteredSuggestions } = this.state;

    // tab key
    if (e.keyCode === 9 && this.props.selectOnTab) {
      if (filteredSuggestions && filteredSuggestions.length > 0) {
        let index = activeSuggestion
        if (activeSuggestion === -1) {
          // neu phan tu dau tien la category thi select chọn phần tử thứ 2
          if (filteredSuggestions[0].category) {
            index = 1
          } else {
            index = 0
          }
        }
        return this.handleOnKeyPress(index, filteredSuggestions)
      }
    }

    // User pressed the enter key
    if (e.keyCode === 13) {
      this.handleOnKeyPress(activeSuggestion, filteredSuggestions)
    }
    // User pressed the up arrow
    else if (e.keyCode === 38) {
      if (activeSuggestion === 0) {
        return;
      }

      this.setState({ activeSuggestion: (activeSuggestion - 1) });
    }
    // User pressed the down arrow
    else if (e.keyCode === 40) {
      if ((activeSuggestion - 1) === filteredSuggestions.length) {
        return;
      }

      this.setState({ activeSuggestion: (activeSuggestion + 1) });
    }
  };

  renderItem = (item) => {
    if (this.props.formatOptionLabel) {
      return this.props.formatOptionLabel(item);
    }

    return item.toString();
  }

  renderNoItem = (item) => {
    if (this.props.formatNoOptionLabel) {
      return this.props.formatNoOptionLabel(item);
    }

    return (
      <em>No suggestions, you're on your own!</em>
    );
  }

  showALl = () => {
    const {showSuggestions, userInput} = this.state;
    if (showSuggestions) {
      this.setState({showSuggestions: !showSuggestions});
    }
    else {
      this.fetchData(userInput);
    }
  }

  closeSuggession = () => {
    this.setState({showSuggestions: false});
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.closeSuggession();
    }
  }

  componentWillMount() {
    this.timer = null;
    this.keywordInput = null;
    if (this.props.onRef) {
      this.props.onRef(undefined);
    }

    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  componentDidMount(){
    if (this.props.onRef) {
      this.props.onRef(this);
    }

    if (this.props.setFocus) {
      this.keywordInput.focus(); 
    }

    if (this.props.initParams) {
      this.props.initParams((option) => {
        if (option) {
          this.setState(option);
          if (option.isResetTextbox) {
            this.setValueBox("");
          }
        }
      }); 
    }

    document.addEventListener('mousedown', this.handleClickOutside);
  }

  render() {
    const {
      handleClearClick,
      handleInputClick,
      onChange,
      onClick,
      onKeyDown,
      renderItem,
      renderNoItem,
      showALl,
      state: {
        activeSuggestion,
        filteredSuggestions,
        showSuggestions,
        isCloseSuggessDelegate,
        userInput,
        userValue,
      },
      props: {
        name,
        hideNarrow,
        hideNoSuggestions,
        placeholder,
        selectOnTab,
        tabIndex,
      }
    } = this;

    let suggestionsListComponent;
    if (showSuggestions && !isCloseSuggessDelegate) {
      if (filteredSuggestions.length) {
        let hasCategory = false
        suggestionsListComponent = (
          <ul className="suggestions form-control">
            {filteredSuggestions.map((item, index) => {
              let className;
              // Flag the active suggestion with a class
              if (index === activeSuggestion) {
                className = "suggestion-active";
              } else if (selectOnTab && activeSuggestion === -1 && index <= 1) {
                // kiem tra 2 item 0 va 1 
                // xem neu co category o itemIndex = 0 thi can selection vào index = 1
                // neu không có category thì selection vào index = 0
                if (index === 0) {
                  // default select dòng đầu tiên
                  if (item.category) {
                    className = "suggestion-category"
                    hasCategory = true
                  } else {
                    className = "suggestion-active"
                  }
                } else if (hasCategory) {
                  className = "suggestion-active"
                }
              }
              return (
                <li className={className} key={index} onClick={onClick.bind(this, item)}>
                  {renderItem(item)}
                </li>
              );
            })}
          </ul>
        );
      } else if (userInput.length > 0 && !hideNoSuggestions) {
        suggestionsListComponent = (
          <div className="no-suggestions">
            {renderNoItem(userInput)}
          </div>
        );
      }
    }
    
    return (
      <Fragment>
        <div className={`suggestion-form ${this.props.className}`} ref={this.setWrapperRef}>
          <div className="d-none show-scan">
            {this.state.scanning ? <Scanner onDetected={this.onDetected} /> : null}
          </div>
          <div className="input-group">
            <input
              type="text"
              tabIndex={tabIndex}
              placeholder={placeholder}
              onChange={onChange}
              onClick={handleInputClick}
              onKeyDown={onKeyDown}
              className="form-control"
              ref={(input) => { this.keywordInput = input; }}
            />
            {userInput && !!userInput.length && ( <i onClick={handleClearClick} title="Xóa nội dung" className={!hideNarrow ? "fa fa-close" : "fa fa-close2"}></i>)}
            {!hideNarrow ? <div onClick={showALl} className="input-group-append"><span className="input-group-text"><i className="icon-arrow-down"></i></span></div> : null}
            {this.props.useScanBarcode ? <button className="d-none show-scan btn-scan-barcode" onClick={this.scan}><i className="fa fa-barcode"></i></button> : null}
            
          </div>
          <input
            name={name}
            type="hidden"
            value={userValue}
          />
          {suggestionsListComponent}
        </div>
      </Fragment>
    );
  }
}

export default Autocomplete;


// WEBPACK FOOTER //
// ./src/views/controls/_Autocomplete.js